import React, { useEffect } from "react"
import { useParams, useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux"
import { Spin, Modal, Typography, Flex } from "antd"
import { CheckCircleOutlined } from "@ant-design/icons"
import { getWaiverSubmissionById } from "store/digital-waiver"
import { SignDocumentModal } from "pagesV2/pro/Embedded/BookingConfirmation/modal/SignDocument"
import { routes } from "router"

const { Title, Text } = Typography

export default function WaiverResumePage() {
  const params = useParams()
  const { uuid, token } = params
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { data: submission, loading } = useSelector((state) => state.digitalWaiver.currentWaiverSubmission)

  useEffect(() => {
    dispatch(getWaiverSubmissionById(token))
  }, [token]) // eslint-disable-line

  useEffect(() => {
    if (submission?.status === "signed") {
      window.history.pushState(null, "", window.location.href)
      const handlePopState = () => window.history.pushState(null, "", window.location.href)
      window.addEventListener("popstate", handlePopState)
      return () => window.removeEventListener("popstate", handlePopState)
    }
  }, [submission?.status])

  if (loading || !submission) {
    return (
      <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Spin size="large" />
      </div>
    )
  }

  if (submission?.status === "signed") {
    return (
      <Flex align="center" justify="center" style={{ minHeight: "100vh", background: "#f5f5f5" }}>
        <Modal
          open
          footer={null}
          closable={false}
          maskClosable={false}
          centered
          width={440}
          styles={{ mask: { background: "transparent" } }}
        >
          <div style={{ textAlign: "center" }}>
            <Flex align="center" justify="center" style={{ width: 56, height: 56, borderRadius: "50%", background: "#e6f4ff", margin: "0 auto 16px" }}>
              <CheckCircleOutlined style={{ fontSize: 24, color: "#1677ff" }} />
            </Flex>
            <Title level={4} style={{ marginBottom: 4 }}>
              Waiver Already Signed
            </Title>
            <Text type="secondary">
              You have already signed this waiver.
            </Text>
          </div>
        </Modal>
      </Flex>
    )
  }

  return (
    <SignDocumentModal
      uuid={uuid}
      waiverSubmissionId={token}
      pendingSubmission={submission?.pending_waiver_submissions || []}
      bookingWaivers={submission?.booking_waivers || []}
      open={true}
      fullScreen
      onCancel={() => navigate(routes.clientWaiverThankYou())}
      onDraftSaved={() => navigate(routes.clientWaiverThankYou(), { state: { isDraft: true } })}
    />
  )
}
